<template>
  <div class="item-status-wrapper">
    <div
      class="flex flex-row px-2 rounded-lg"
      :style="{ 'background-color': calBgColor }"
    >
      <div
        class="status-text flex flex-col items-center justify-center"
        :style="{ color: btColor }"
      >
        {{ this.status }}
        <slot name="elapse-time"></slot>
      </div>

      <div class="flex flex-col justify-center ml-1">
        <v-progress-circular
          v-if="
            status == POD_STATUS.updating ||
            status == POD_STATUS.installing ||
            status == POD_STATUS.restarting ||
            status == POD_STATUS.restart ||
            status == POD_STATUS.resume ||
            status == POD_STATUS.loading
          "
          indeterminate
          :size="18"
          width="2"
          :color="btColor"
        ></v-progress-circular>

        <Tooltip
          v-else-if="
            [POD_STATUS.failed, POD_STATUS.error, POD_STATUS.pending].includes(
              status,
            ) && tooltip != ''
          "
          :text="tooltip"
          position="right"
          targetSelf
          :contentClass="
            status == POD_STATUS.failed ? 'p-2 text-sm inline-block' : ''
          "
        >
          <v-icon
            size="medium"
            :color="btColor"
            @click="
              () => {
                viewRDEState(1);
              }
            "
          >
            mdi-alert-circle
          </v-icon>
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { POD_STATUS } from "@/service/constants";

const DEFAULT_COLOR = "#768192";

export default {
  props: {
    status: { type: String, default: "Loading" },
    tooltip: { type: String },
    item: { type: Object },
    viewRDEState: { type: Function, default: () => {} },
    rdeColor: { type: String, default: DEFAULT_COLOR },
  },
  data() {
    return {
      POD_STATUS,
    };
  },
  computed: {
    btStatus() {
      return POD_STATUS[this.status?.toLowerCase()] != null
        ? POD_STATUS[this.status?.toLowerCase()]
        : POD_STATUS.created;
    },
    btColor() {
      const color = this.isNullOrEmpty(this.rdeColor)
        ? DEFAULT_COLOR
        : this.rdeColor;
      return color;

      // switch (this.status?.toLowerCase()) {
      //   case "running": {
      //     return "#00A738"; // Green
      //   }
      //   case "loading":
      //   case "installing":
      //   case "updating":
      //   case "pending":
      //   case "restarting":
      //   case "resume":
      //   case "restart": {
      //     return "#DF6A08"; // Orange
      //   }
      //   case "created": {
      //     return "#3399FF"; // Blue
      //   }
      //   case "failed": {
      //     return "#E55353"; // Red
      //   }
      //   case "stop":
      //   case "shutdown": {
      //     return "#768192"; // Grey
      //   }
      //   default:
      //     return "#768192"; // Grey
      // }
    },
    bgColor() {
      switch (this.status?.toLowerCase()) {
        case "running": {
          return this.$helper.hex2rgba("#00A738", 0.1); // Green
        }
        case "loading":
        case "installing":
        case "updating":
        case "pending":
        case "restarting":
        case "resume":
        case "restart": {
          return this.$helper.hex2rgba("#DF6A08", 0.1); // Orange
        }
        case "created": {
          return this.$helper.hex2rgba("#3399FF", 0.1);
        }
        case "failed": {
          return this.$helper.hex2rgba("#E55353", 0.1);
        }
        case "stop":
        case "shutdown": {
          return this.$helper.hex2rgba("#768192", 0.1);
        }
        default:
          return this.$helper.hex2rgba("#768192", 0.1);
      }
    },
    calBgColor() {
      if (this.rdeColor && this.rdeColor != "") {
        return this.$helper.hex2rgba(this.rdeColor, 0.1);
      } else {
        return this.$helper.hex2rgba(DEFAULT_COLOR, 0.1);
      }
    },
  },
  methods: {
    isNullOrEmpty(value) {
      return value == null || value.trim() === "";
    },
  },
};
</script>

<style type="scss">
.item-status-wrapper {
  flex-basis: content;
  padding: 3px 0;
  width: fit-content;
  .status-text {
    font-size: 12px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0.0015em;
    text-align: center;
    min-width: 45px;
  }
}
</style>
